module.exports = __webpack_public_path__ + "h5/img/6.bdc5ccc5.jpg";